import { addDays, differenceInDays } from './dateFormatter'

interface IAccessDays {
  expireDate: string
  availableUntil?: string
  availableTimeLength?: number
  activatedAt: string
  unlimited?: boolean
}

export function getAccessDays({
  availableUntil,
  expireDate,
  availableTimeLength,
  activatedAt,
  unlimited,
}: IAccessDays) {
  if (unlimited) {
    return null
  }

  // Prioridade 1: Data específica da matrícula (availableUntil)
  if (availableUntil) {
    return {
      days: differenceInDays(new Date().toDateString(), availableUntil),
      expireDate: availableUntil,
    }
  }

  // Prioridade 2: Tempo de acesso do produto (availableTimeLength)
  if (availableTimeLength) {
    return {
      days: differenceInDays(
        new Date().toDateString(),
        addDays(activatedAt, availableTimeLength),
      ),
      expireDate: addDays(activatedAt, availableTimeLength),
    }
  }

  // Prioridade 3: Data do produto (expireDate)
  if (expireDate) {
    return {
      days: differenceInDays(new Date().toDateString(), expireDate),
      expireDate,
    }
  }

  return null
}
